import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { LocationService } from 'src/app/core/services/admin/location/location.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { DISPLAY_TEXT } from '../add-group/add-group.constants';

@Component({
  selector: 'app-add-group',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.scss'],
  standalone: false,
})
export class AddGroupComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<AddGroupComponent>);
  private fb = inject(FormBuilder);
  private locationService = inject(LocationService);
  private commonUtils = inject(CommonUtils);

  readonly CONSTANTS = DISPLAY_TEXT;
  readonly BUTTON_TYPES = BUTTON_TYPES;

  groupForm!: FormGroup;

  ngOnInit(): void {
    this.groupForm = this.fb.group({
      ['groupCode']: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(10)]),
      ],
      ['description']: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(30)]),
      ],
    });
  }

  onSubmit() {
    const payload = {
      code: this.groupForm.get('groupCode')?.value,
      name: this.groupForm.get('description')?.value,
    };
    this.locationService
      .addLocationGroup(payload)
      .pipe(take(1))
      .subscribe(() => {
        this.commonUtils.updateBannerType(BANNER_TYPE.API_SUCCESS);
        this.dialogRef.close(this.groupForm.value);
      });
  }

  onClose() {
    this.commonUtils.openExitModal(this.groupForm.dirty);
  }
}
